export const handleKeyDown = (e: any, keyCode: string, nextFunction: any) => {
	if (e.key === keyCode) {
		nextFunction();
	}
};
